import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import minMax from 'dayjs/plugin/minMax';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export type Dayjs = dayjs.Dayjs;

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(minMax);

export const VALID_DATE_INPUT_FORMATS = [
	'M-D-YY',
	'M-D-YYYY',
	'M-DD-YY',
	'M-DD-YYYY',
	'MM-D-YY',
	'MM-D-YYYY',
	'MM-DD-YY',
	'MM-DD-YYYY',
	'M/D/YY',
	'M/D/YYYY',
	'M/DD/YY',
	'M/DD/YYYY',
	'MM/D/YY',
	'MM/D/YYYY',
	'MM/DD/YY',
	'MM/DD/YYYY',
	'YY-M-D',
	'YY-M-DD',
	'YY-MM-D',
	'YY-MM-DD',
	'YYYY-M-D',
	'YYYY-M-DD',
	'YYYY-MM-D',
	'YYYY-MM-DD',
	'YY/M/D',
	'YY/M/DD',
	'YY/MM/D',
	'YY/MM/DD',
	'YYYY/M/D',
	'YYYY/M/DD',
	'YYYY/MM/D',
	'YYYY/MM/DD',
];

const today = (facilityTimezone: string | undefined = 'UTC') => {
	const now = dayjs().tz(facilityTimezone).format('YYYY-MM-DD HH:mm:ss');
	return dayjs(now).toDate();
};

const timestampToTimezone = (timestamp: Date, tz: string | undefined = 'UTC', format: string = 'MM/DD/YYYY') =>
	dayjs(timestamp).tz(tz).format(format);

function getDayjs(date: string | Date) {
	return typeof date === 'string' ? dayjs.utc(date, 'YYYY-MM-DD') : dayjs.utc(date);
}

function isOverlap(
	startDate1: string | Date,
	endDate1: string | Date,
	startDate2: string | Date,
	endDate2: string | Date,
) {
	return (
		getDayjs(startDate1).isSameOrBefore(getDayjs(endDate2)) &&
		getDayjs(endDate1).isSameOrAfter(getDayjs(startDate2))
	);
}

export { dayjs, isOverlap, timestampToTimezone, today };
